export const SET_USER_PROFILE = "SET_USER_PROFILE"
export const SET_USER_TOKEN = "SET_USER_TOKEN"